<template>
  <div class="background-modal">
    <div class="wrapper-modal">
      <div class="wrapper-title">
        <p class="title">Anulación No. provisional 1232143</p>
        <CloseButton @click="closeModal" />
      </div>
      <div class="wrapper-form">
        <GeneralTextArea
          v-model:text="reason.val"
          :value="reason.val"
          :label="'Motivo de anulación'"
          :has-error="reason.enabled"
          :error="reason.errors.length === 0 ? '' : reason.errors[0]"
        />
      </div>
      <StandardButton
        :buttonLabel="'Anular'"
        class="margin-button"
        :is-disabled="successForm"
        @click="nullify"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import GeneralTextArea from "@/components/commons/controls/GeneralTextArea.vue";
import { reasonCancellationValidator } from "@/ux/sharedComponents/validators/reasonCancellationValidator";
import CloseButton from "@/components/commons/controls/CloseButton.vue";
import StandardButton from "@/components/commons/controls/StandardButton.vue";

export default defineComponent({
  name: "ModalReasonCancellation",
  components: {
    GeneralTextArea,
    CloseButton,
    StandardButton,
  },

  setup(props, context) {
    const { reason, successForm, reset } = reasonCancellationValidator();

    function closeModal() {
      context.emit("closeReasonCancellation");
    }

    function nullify() {
      context.emit("nullify", reason.value.val);
    }

    return {
      closeModal,

      reason,
      successForm,
      reset,
      nullify,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/sharedComponents/styles/modalReasonCancellationStyle";
</style>
